import i18next from 'i18next';
import HttpBackend from 'i18next-http-backend';
// import LanguageDetector from 'i18next-browser-languagedetector';

i18next
  .use(HttpBackend)
  // .use(LanguageDetector) // 偵測瀏覽器語系
  .init({
    whitelist: ['zh_TW', 'en_US'],
    fallbackLng: 'zh_TW',
    // debug: true,
    lng: 'zh_TW',
    load: 'currentOnly',
    ns: ['default'], // 語系的 loading namespace 如語系檔案名稱 common.js
    defaultNS: 'default', // 預設的 namespace name
    interpolation: {
      escapeValue: false, // not needed for react!!
    },
    backend: {
    // 設定語系檔案的 server 路徑, 會以GET的方式跟 server 要檔案
    // lng = 語系代碼 ns = namespace
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
  });

export default i18next;
